import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { ClientesServicios } from "../ClientesServicios/ClientesServicios";
import { ACTSeleccionarServicios } from "./ACTSeleccionarServicios";
import { ClientesTiendasServicios } from "./ClientesTiendasServicios";
import { ClientesTiendasServiciosOverrides } from "./ClientesTiendasServiciosOverrides";

const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente ID' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PK, prompt: 'Tienda ID' }),
        c_servicio_id: new EntityColumn<string>({ name: 'c_servicio_id', type: 'char', length: 20, flags: c.PK, prompt: 'Servicio' }),
        dt_fecha_inicio: new EntityColumn<Date>({ name: 'dt_fecha_inicio', type: 'datetime', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha de Inicio' }),
        i_dias_envio_informacion: new EntityColumn<number>({ name: 'i_dias_envio_informacion', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Dias de Envío de Información' }),
        i_dias_finalizacion: new EntityColumn<number>({ name: 'i_dias_finalizacion', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Dias de finalización' }),
        vc_observaciones: new EntityColumn<string>({ name: 'vc_observaciones', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Observaciónes' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        clts_brwStandard: {
            name: 'clts_brwStandard', keyMappings: { c_servicio_id: 0 },
            gridColumnsOverrides: ClientesTiendasServiciosOverrides
        }, 
        clts_brwNoEnTienda: { name: 'clts_brwNoEnTienda', keyMappings: { c_servicio_id: 0 } }
    }
)

const lookups = () =>
(
    {
        'Servicios': {
            name: 'Servicios',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ClientesServicios(client, parentKeys)
        },
        'ServiciosNoEnTienda': {
            name: 'ServiciosNoEnTienda',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            view: 'clts_brwNoEnTienda',
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ClientesTiendasServicios(client, parentKeys)
        }
    }
)

const clientActions = () =>
(
    {
        ACTSeleccionarServicios: ACTSeleccionarServicios,
    }
)

export class ClientesTiendasServiciosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();

    constructor() {
        super('ClientesTiendasServicios');
    }
}